export const TOGGLE_MOBILE_VIEW = {
  MobileReductionV1: "MobileReductionV1",
} as const;

export type ToggleMobileView = (typeof TOGGLE_MOBILE_VIEW)[keyof typeof TOGGLE_MOBILE_VIEW];

export const isMobileReductionV1 = (toggle?: string | null): boolean => toggle === TOGGLE_MOBILE_VIEW.MobileReductionV1;
